/* PP MASCOT — reveal the characters as the shopper scrolls to them.
 *
 * Progressive enhancement, deliberately: the CSS only hides a mascot once THIS script has added
 * .is-revealed. If the script never runs — blocked, errored, old browser — every character stays
 * visible exactly as it is today. Hiding first and revealing with JS would mean a script failure
 * silently deletes the brand's narrators from the page.
 *
 * No dependencies, no framework. It runs once per element and then stops observing.
 */
(() => {
  const SELECTOR = '.pp-mascot--anim';

  // The visitor's motion preference wins over the merchant setting. Checked here as well as in
  // CSS so we do not even pay for an observer when the animation would not run anyway.
  const prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        // The arrival plays once; keeping the observer alive would re-trigger it every time the
        // shopper scrolls past, which turns a greeting into a twitch.
        observer.unobserve(entry.target);
      }
    },
    {
      // Start slightly before the character is fully on screen so the entrance finishes about
      // when it reaches a comfortable reading position, instead of animating in the corner.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.15,
    }
  );

  const reveal = (root) => {
    for (const el of (root || document).querySelectorAll(SELECTOR)) {
      if (el.dataset.ppMascotBound) continue;
      el.dataset.ppMascotBound = '1';
      el.classList.add('is-revealed');
      observer.observe(el);
    }
  };

  reveal(document);

  // Sections re-render on their own in the theme editor and when a variant changes, which replaces
  // the markup and drops our classes. Re-scan so a mascot inside a re-rendered section still works.
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
  document.addEventListener('shopify:section:select', (event) => reveal(event.target));
})();
